// extracted by mini-css-extract-plugin
export var column = "ColumnsTemplate-module--column--i4tFe";
export var limitWidthOnLargeScreens = "ColumnsTemplate-module--limitWidthOnLargeScreens--119uF";
export var row = "ColumnsTemplate-module--row--mmDaL";
export var title = "ColumnsTemplate-module--title--JdcYK";